/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Xybutton.vue?vue&type=template&id=166ba94e&scoped=true"
import script from "./Xybutton.vue?vue&type=script&lang=js"
export * from "./Xybutton.vue?vue&type=script&lang=js"
import style0 from "./Xybutton.vue?vue&type=style&index=0&id=166ba94e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ba94e",
  null
  
)

export default component.exports